<template>
  <v-row>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :bottom="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <!-- Dialog for file rename -->
    <v-dialog v-model="dialogFileRename" max-width="400px">
      <v-card flat tile color="white">
        <v-card-subtitle class="primary--text white title px-1 pt-2 pb-1"
          >Rename File</v-card-subtitle
        >
        <v-card-text class="py-0 px-1">
          <v-row no-gutters>
            <v-col>
              <input class="form-control rounded-0" v-model="file_rename" />
            </v-col>
          </v-row>
        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              tile
              small
              depressed
              color="primary"
              class="font-weight-bold mr-2"
              @click="updateFile(true, false)"
              >RENAME</v-btn
            >
            <v-btn
              tile
              small
              depressed
              color="error"
              class="font-weight-bold ml-2"
              @click="dialogFileRename = false"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for file tags update -->
    <v-dialog v-model="dialogFileTags" max-width="400px">
      <v-card flat tile color="white">
        <v-card-title class="primary--text white title px-1 pt-2"
          >Update File Tags</v-card-title
        >
        <v-card-text class="px-1">
          <v-row no-gutters class="px-1">
            <v-col>
              <v-autocomplete
                class="form-control rounded-0 caption text-uppercase"
                :items="allFilesTags"
                v-model="new_file_tags"
                :search-input.sync="tag_search"
                placeholder="Select Tag"
                solo
                chips
                small-chips
                deletable-chips
                multiple
                item-text="tag"
                item-value="tag"
                style="float: right"
                color="white"
                item-color="primary"
                hide-selected
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              tile
              small
              depressed
              color="primary"
              class="font-weight-bold mr-2"
              @click="updateFile(false, true)"
              >SAVE</v-btn
            >
            <v-btn
              tile
              small
              depressed
              color="error"
              class="font-weight-bold ml-2"
              @click="onCloseFileTagDialog"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row no-gutters>
      <v-col>
        <v-card flat tile color="white">
          <v-card-subtitle class="primary--text text-center white caption"
            >Drag & Drop your files anywhere below</v-card-subtitle
          >

          <v-card-text
            class="px-0 py-0"
            @dragover.stop.prevent="onDragOver"
            @dragenter.stop.prevent="onDragEnter"
            @dragleave.stop.prevent="onDragLeave"
            @drop.stop.prevent="onFileUpload"
          >
            <v-card tile elevation="1" height="300">
              <v-overlay v-model="overlay" absolute color="primary lighten-2">
                <v-row class="mt-16" no-gutters>
                  <v-col>
                    <v-row justify="center">
                      <v-icon size="70" color="primary" class="mt-16"
                        >mdi-cloud-upload</v-icon
                      >
                    </v-row>
                    <v-row>
                      <v-alert dense tile text class="primary--text caption"
                        >Drop your file(s) for an instant upload</v-alert
                      >
                    </v-row>
                  </v-col>
                </v-row>
              </v-overlay>
              <v-data-table
                dense
                :search="tableSearch"
                :headers="$root.is_admin ? tableHeader : customerTableHeader"
                :items="sortedFiles"
                no-data-text
                hide-default-footer
              >
                <template v-slot:item="{ item }">
                  <tr :key="item.file_id" v-if="item.visibility || $root.is_admin">
                    <td class="text-left pl-2">
                      <v-row no-gutters>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                              style="font-size: 11px; cursor: pointer"
                              @click="onFileView(item)"
                              >{{ item.file_name }}</span
                            >
                          </template>
                          Click on open file
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-if="canModifyFile(item)"
                              v-on="on"
                              size="14"
                              color="grey"
                              @click="onFileRename(item)"
                              >mdi-pencil</v-icon
                            >
                          </template>
                          Rename file
                        </v-tooltip>
                      </v-row>
                    </td>
                    <td class="text-left pl-2">
                      <v-row no-gutters>
                        <span class="text-uppercase" style="font-size: 11px">
                          {{ item.file_tags.join(", ") }}
                        </span>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-if="canModifyFile(item)"
                              v-on="on"
                              size="14"
                              color="grey"
                              @click="onUpdateFileTags(item)"
                              >mdi-pencil</v-icon
                            >
                          </template>
                          Update file tags
                        </v-tooltip>
                      </v-row>
                    </td>
                    <td style="font-size: 11px" class="text-center">
                      {{ item.updated.split(" ")[0] }}
                    </td>
                    <td style="font-size: 11px" class="text-center">
                      {{ item.file_size }}KB
                    </td>
                    <td style="font-size: 11px" class="text-center" v-if="$root.is_admin">
                      {{ item.user.split("@")[0] }}
                    </td>
                    <td class="text-center" v-if="$root.is_admin">
                      <v-icon
                        :color="item.visibility ? 'primary' : 'grey'"
                        @click="toggleVisibility(item)"
                        >mdi-eye</v-icon
                      >
                    </td>

                    <td class="text-center">
                      <v-btn
                        x-small
                        icon
                        color="error"
                        :disabled="!canModifyFile(item)"
                        @click="onFileDelete(item)"
                      >
                        <v-icon size="25">mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "@/const";
export default {
  props: ["shipment_order_id", "company_id", "files"],
  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      CONSTANT: constant,
      selectedFile: null,
      file_rename: null,
      new_file_tags: [],
      syncSelectedFile: {},
      dialogFileRename: false,
      dialogFileTags: false,

      overlay: false,

      allFilesTags: [],
      tag_search: null,

      tableSearch: null,

      tableHeader: [
        {
          text: "Name",
          align: "center",
          description: "File name",
          showTooltip: true,
          value: "file_name",
          sortable: true,
          //   divider: true,
        },
        {
          text: "Tags",
          align: "center",
          description: "File tags",
          showTooltip: true,
          value: "file_tags",
          sortable: false,
          //   divider: true,
        },
        {
          text: "Modified",
          align: "center",
          description: "Last modified on",
          showTooltip: true,
          value: "updated",
          sortable: true,
          //   divider: true,
        },
        {
          text: "Size",
          align: "center",
          description: "File size",
          showTooltip: true,
          value: "file_size",
          sortable: true,
          //   divider: true,
        },
        {
          text: "By",
          align: "center",
          description: "Last updated by this user",
          showTooltip: true,
          value: "user",
          sortable: true,

          //   divider: true,
        },
        {
          text: "Customer Access",
          align: "center",
          description: "Customer view access",
          showTooltip: true,
          value: "visibility",
          sortable: true,
          //   divider: true,
        },
        {
          text: "",
          align: "center",
          description: "",
          showTooltip: false,
          value: "delete",
          sortable: false,
          //   divider: true,
        },
      ],

      customerTableHeader: [
        {
          text: "Name",
          align: "center",
          description: "File name",
          showTooltip: true,
          value: "file_name",
          sortable: true,
          //   divider: true,
        },
        {
          text: "Tags",
          align: "left",
          description: "File tags",
          showTooltip: true,
          value: "file_tags",
          sortable: false,
          //   divider: true,
        },
        {
          text: "Modified",
          align: "center",
          description: "Last modified on",
          showTooltip: true,
          value: "updated",
          sortable: true,
          //   divider: true,
        },
        {
          text: "Size",
          align: "center",
          description: "File size",
          showTooltip: true,
          value: "file_size",
          sortable: true,
          //   divider: true,
        },
        {
          text: "",
          align: "center",
          description: "",
          showTooltip: false,
          value: "delete",
          sortable: false,
          //   divider: true,
        },
      ],
    };
  },

  watch: {
    tag_search(val) {
      // filter to check if this search val produces a result
      if (val && val.length > 1) {
        let items = this.allFilesTags.filter((item) => {
          return item.tag.indexOf(val.toLowerCase()) > -1;
        });

        if (items.length < 1) {
          this.allFilesTags.push({
            tag: val.toUpperCase(),
            type: "files",
          });
        }
      }
    },
  },

  mounted() {
    this.loadFileTags();
  },

  methods: {
    /**
     * Load File tags
     */
    async loadFileTags() {
      let resp = await this.$https.get(`/api/tags/list?trash=false&type=files`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        resp.data.data.forEach((item) => {
          this.allFilesTags.push({
            tag: item.tag.toUpperCase(),
            type: item.type,
            name: item.name,
            tag_id: item.tag_id,
            trash: item.trash,
          });
        });
      } else {
        this.allFilesTags = [];
      }
    },

    /**
     *  on drag Over
     */
    onDragOver() {
      this.overlay = true;
    },

    /**
     *  on drag Enter
     */
    onDragEnter() {
      this.overlay = true;
    },

    /**
     *  on drag Leave
     */
    onDragLeave() {
      setTimeout(() => {
        this.overlay = false;
      }, 2000);
    },

    /**
     *  on drop and file upload
     */
    async onFileUpload(e) {
      this.overlay = false;
      this.$root.blockUImsg = "Uploading file(s)..";
      this.$root.blockUIshow = true;

      let totalFiles = e.dataTransfer.files.length;

      // instantiate formData
      let formData = new FormData();

      // append the files
      for (let i = 0; i < totalFiles; i++) {
        formData.append("files", e.dataTransfer.files[i]);
      }

      formData.append("category", "shipments");
      formData.append("company_id", this.company_id);
      formData.append("shipment_order_id", this.shipment_order_id);

      let resp = await this.$https.post(`/api/files/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: this.$root.access_token,
        },
      });

      // response
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.files.push(...resp.data.data);
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        console.log("Error uploading shipment files", resp.data);
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }
      this.$root.blockUIshow = false;
      // emit an update
      this.$emit("updated", true);
    },

    /** If user can modify file */
    canModifyFile(item) {
      return this.$root.email == item.permission.owner || this.$root.is_admin;
    },

    /**
     * View file
     */
    async onFileView(file) {
      this.$root.blockUImsg = "Loading selected file..";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(`/api/files/${file.file_id}`);

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        window.open(resp.data.data);
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * On Rename file
     */
    onFileRename(file) {
      this.file_rename = file.file_name;
      this.syncSelectedFile = file;
      this.dialogFileRename = true;
    },

    /**
     * On update file tags
     */
    onUpdateFileTags(file) {
      this.new_file_tags = [];
      file.file_tags.forEach((tag) => {
        this.new_file_tags.push(tag.toUpperCase());
      });

      this.syncSelectedFile = file;
      this.dialogFileTags = true;
    },

    /**
     * Update file information
     */
    async updateFile(rename = false, newTags = false) {
      this.$root.blockUImsg = "Updating file..";
      this.$root.blockUIshow = true;

      // if file rename
      if (rename) {
        this.syncSelectedFile.file_name = this.file_rename;
      }

      // if file tags
      if (newTags) {
        this.syncSelectedFile.file_tags = this.new_file_tags;
      }

      let resp = await this.$https.put(
        `/api/files/${this.syncSelectedFile.file_id}`,
        this.syncSelectedFile
      );
      // console.log("resp: ", resp.data)

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.file_rename = null;
        this.new_file_tags = [];
        // sync the updated booking
        this.syncSelectedFile = Object.assign(this.syncSelectedFile, resp.data.data);

        // emit an update
        this.$emit("updated", true);
        this.dialogFileRename = false;
        this.dialogFileTags = false;
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * On close file dialog
     */
    onCloseFileTagDialog() {
      this.new_file_tags = [];
      this.dialogFileRename = false;
      this.dialogFileTags = false;
    },

    /**
     * Toggle Visibility
     */
    async toggleVisibility(file) {
      let postform = {
        visibility: !file.visibility,
      };
      let resp = await this.$https.put(`/api/files/${file.file_id}/visibility`, postform);

      file.visibility = postform.visibility;
    },

    /**
     * Delete file
     */
    async onFileDelete(file) {
      this.$root.blockUImsg = "Deleting file..";
      this.$root.blockUIshow = true;

      let resp = await this.$https.delete(`/api/files/${file.file_id}`);

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the UI
        this.files = this.files.filter((item) => {
          return item != file;
        });

        // emit an update
        this.$emit("updated", true);
        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },
  },

  computed: {
    /** Sort the files */
    sortedFiles() {
      return this.files.sort(function (a, b) {
        return new Date(b.updated) - new Date(a.updated);
      });
    },

    /** Get value for if booking files are uploaded */
    bookingFilesUploaded() {
      let ret = [];
      this.files.forEach((file) => {
        if (file.file_tags.includes("CINV")) {
          ret.push("CINV");
        }
        if (file.file_tags.includes("CPL")) {
          ret.push("CPL");
        }

        // if CIPL, then this a combination of both CINV & CPL
        if (file.file_tags.includes("CIPL")) {
          ret.push("CIPL");
        }
      });

      // if completed, then return true else false
      if (ret.length > 1 || ret.includes("CIPL")) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
/* .v-data-table {
  border: 2px solid #e0e0e0;
} */
::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}

.v-data-table tbody tr {
  text-align: left;
}

.v-data-table tbody tr .custom-table-tr {
  text-align: center;
}

/* .v-data-table td {
  padding: 0px;
  height: 30px;
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-top: thin solid rgba(0, 0, 0, 0.12);
} */
</style>
